module.exports = __webpack_public_path__ + "img/16581305_L.cc9f5b86.png";